import { render, staticRenderFns } from "./facebookOverview.vue?vue&type=template&id=76a763f7&scoped=true&"
import script from "./facebookOverview.vue?vue&type=script&lang=js&"
export * from "./facebookOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76a763f7",
  null
  
)

export default component.exports